import { InternalStepOption } from '@booking-booster-client/models';

export const step1: InternalStepOption = {
  anchorId: 'new-budget',
  stepId: 'new-budget',
  titleTranslationKey: 'ui_tours.settings_advertisers_detail.step1.title',
  contentTranslationKey: 'ui_tours.settings_advertisers_detail.step1.content',
  route:
    'settings/advertisements/advertisers/${searchEngineConnectionsId}/budget',
  contextIsRequired: true,
  delayAfterNavigation: 300,
  popoverClass: 'custom-modal-ui-tour-advertisements-detail',
};
